import React,{useState} from "react";
import {Modal,Button,Form} from "react-bootstrap";

export default function InsertProjectImageModal({show,setShow,onInsert}){

const [file,setFile]=useState(null)
const [url,setUrl]=useState("")

const handleInsert=()=>{

if(file){

const imageURL = URL.createObjectURL(file)

onInsert(imageURL)

}

if(url){

onInsert(url)

}

setShow(false)

}

return(

<Modal
show={show}
onHide={()=>setShow(false)}
centered
dialogClassName="insert-image-modal"
>

<Modal.Header closeButton>

<Modal.Title>
Insert Image
</Modal.Title>

</Modal.Header>


<Modal.Body>

<Form>

<Form.Group className="mb-4">

<Form.Label className="label-title">
Select from files
</Form.Label>

<Form.Control
type="file"
onChange={(e)=>setFile(e.target.files[0])}
/>

</Form.Group>


<Form.Group>

<Form.Label className="label-title">
Image URL
</Form.Label>

<Form.Control
value={url}
onChange={(e)=>setUrl(e.target.value)}
/>

</Form.Group>

</Form>

</Modal.Body>


<Modal.Footer className="border-0">

<Button
className="insert-btn"
onClick={handleInsert}
>
Insert Image
</Button>

</Modal.Footer>


<style>{`

.insert-image-modal .modal-dialog{
max-width:640px;
}

.label-title{
font-weight:600;
margin-bottom:8px;
}

.insert-btn{
background:#f97316;
border:none;
padding:8px 20px;
border-radius:6px;
}

.insert-btn:hover{
background:#ea580c;
}

.insert-image-modal .modal-footer{
display:flex;
justify-content:flex-end;
}

`}</style>

</Modal>

)

}